import config from "../../_helpers/config";

export const apiFetcher = (path, options, isPostingJson = true, returnHeaders = false) => {
    const at = window.localStorage.getItem("at");

    let url = `${config.MOBILIZEI_API_BASE_URL}/${path}`;

    if (!options?.headers) options = { ...options, headers: {} }
    options.headers['Authorization'] = `Bearer ${at}`;

    if (isPostingJson)
        options.headers['Content-Type'] = 'application/json';

    return fetch(url, options).then(response => {
        if (response.status === 204) {
            return;
        }

        // Handle 401 and 403 errors
        if (response.status === 401 || response.status === 403) {

            // Remove the at from the local storage and reload to
            // redirect to login
            window.localStorage.removeItem("at");

            return Promise.reject();
        }

        // handle 404 errors
        if (response.status === 404) {
            return Promise.reject();
        }

        return response.json().then(data => {
            if (!response.ok) {
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            if (returnHeaders) {
                return { data, headers: response.headers }
            } else {
                return data;
            }
        });
    });
};